import { NavLink } from "react-router";
import React from "react";
import ImgixFluidImage from "./ImgixFluidImage";
import PlaceHolderImage from "./placeHolderImage";

const FeaturedCard = ({image, title, subtitle, href, ar, sizes = "100vw"}) => {

  const finalImage = image ? <ImgixFluidImage width={545} attribution={image.attribution} image={image} sizes={sizes} ar={ar||4/2} focalPoint={image.focalPoint} /> : <PlaceHolderImage/>;

  return (
    <li className="box box--featured box--secondary swiper-slide">
      <div className="box__inner">
        <NavLink to={href} className="box__link-main" aria-label={`Read more about this article: ${title}`} />
        <figure className="box__image image-fit js-image-fit h-full">
	        <span className="box__image-text">Featured</span>
            {finalImage}
	    </figure>
        <div className="box__body">
          <p className="box__title h6">{title}</p>
          <div className="box__subtitle" dangerouslySetInnerHTML={{ __html: subtitle }}/>
          <div className="box__link link-more text-gray-3" aria-label={`Read more about ${title}`}>Read more</div>
        </div>
      </div>
  </li>
  );
}

export default FeaturedCard;
